module.exports = __webpack_public_path__ + "media/images/input_state_icon/dots-16fa359b528df1b54a225a68253e1f2c.svg";